import { useState } from 'react'
import { Box, Flex, Text, Button } from '@chakra-ui/react'
import { useAuth } from '@/contexts/AuthContext'

export default function ImpersonationBanner() {
  const { user, impersonatorId, stopImpersonation } = useAuth()
  const [isStopping, setIsStopping] = useState(false)

  if (!impersonatorId || !user) return null

  const handleStop = async () => {
    setIsStopping(true)
    try {
      await stopImpersonation()
      window.location.href = '/'
    } catch (error) {
      console.error('Failed to stop impersonation:', error)
      setIsStopping(false)
    }
  }

  return (
    <Box
      bg="orange.500"
      color="white"
      px={{ base: 3, md: 6 }}
      py={2}
      position="sticky"
      top={0}
      zIndex={1100}
      boxShadow="md"
    >
      <Flex align="center" justify="space-between" gap={4} flexWrap="wrap">
        <Flex align="center" gap={3} minW={0}>
          <Text fontSize="sm" fontWeight="medium" isTruncated>
            You&apos;re logged in as {user.name}
          </Text>
        </Flex>
        <Button
          size="sm"
          variant="outline"
          colorScheme="whiteAlpha"
          color="white"
          borderColor="whiteAlpha.700"
          _hover={{ bg: 'whiteAlpha.300' }}
          onClick={handleStop}
          isLoading={isStopping}
        >
          Return to being myself
        </Button>
      </Flex>
    </Box>
  )
}
